import React from 'react';
import { motion } from 'framer-motion';
export function CostComparison() {
  const rows = [{
    sin: 'Apostás en cada partido del Mundial sin análisis',
    costo: 'Capital quemado en 104 decisiones sin criterio'
  }, {
    sin: 'Seguís picks de grupos de WhatsApp sin entender el razonamiento',
    costo: 'Dependencia sin aprendizaje — el próximo torneo empezás de cero'
  }, {
    sin: 'Hacés combinadas de 5+ equipos porque "la cuota es grande"',
    costo: 'Matemáticamente, menos del 10% de probabilidad de acertar'
  }, {
    sin: 'Perdés 3 seguidas y apostás más para recuperar',
    costo: 'El patrón más destructivo del apostador argentino — y el más común'
  }, {
    sin: 'No sabés calcular si una cuota tiene value real',
    costo: 'Apostás siempre en contra del mercado sin saberlo'
  }, {
    sin: 'No tenés registro de tus apuestas',
    costo: 'Nunca sabés qué funciona y qué no — cada torneo empezás de cero'
  }, {
    sin: 'No sabés distinguir una plataforma seria de una trampa',
    costo: 'Riesgo real de perder capital en plataformas sin regulación'
  }, {
    sin: 'El Mundial termina y no sabés exactamente qué salió mal',
    costo: '39 días de torneo sin aprendizaje documentado'
  }];
  return <section className="py-20 bg-zinc-900 text-white" data-id="element-46">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-47">
        <div className="text-center mb-12" data-id="element-48">
          <h2 className="text-3xl md:text-4xl font-extrabold mb-4" data-id="element-49">
            ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
          </h2>
        </div>

        <div className="overflow-x-auto pb-4 mb-12" data-id="element-50">
          <div className="min-w-[600px]" data-id="element-51">
            <div className="grid grid-cols-2 gap-4 mb-4 px-4" data-id="element-52">
              <div className="font-bold text-amber-300 uppercase text-sm tracking-wider" data-id="element-53">
                Sin el Masterpack
              </div>
              <div className="font-bold text-red-400 uppercase text-sm tracking-wider" data-id="element-54">
                Costo real
              </div>
            </div>

            <div className="space-y-2" data-id="element-55">
              {rows.map((row, i) => <div key={i} className="grid grid-cols-2 gap-4 bg-black/60 rounded-xl p-4 items-center border border-amber-900/30" data-id="element-56">
                  <div className="text-zinc-100 font-medium" data-id="element-57">{row.sin}</div>
                  <div className="text-red-300 font-medium" data-id="element-58">{row.costo}</div>
                </div>)}
            </div>
          </div>
          <p className="text-center text-sm text-amber-500 mt-4 md:hidden" data-id="element-59">
            ← Scroll to see full table →
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center bg-gradient-to-br from-amber-500 to-yellow-600 rounded-2xl p-8 md:p-12 shadow-2xl" data-id="element-60">
          <p className="md:text-2xl font-medium text-black mb-4 text-[16px]" data-id="element-61">
            El próximo partido del Mundial puede encontrarte diferente.
          </p>
          <p className="md:text-4xl font-black text-black text-[20px]" data-id="element-62">
            "La próxima jornada, vas a saber exactamente qué mercado apostar y
            por qué." 🏆🇦🇷
          </p>
        </motion.div>
      </div>
    </section>;
}